// packages/shared-hooks/src/clients/keys.ts
//
// Query-key factory for the Clients aggregate (#601). Centralised so every
// mutation that needs to invalidate (root patch, child writes, version
// restore) targets the SAME shapes the list / detail / versions hooks read
// — divergence would silently leave stale rows in the cache.
//
// Shapes:
//   - `lists()` / `list(filter)` — the list view; the prefix
//     `clientsKeys.lists()` matches every filtered slot so any aggregate
//     mutation can invalidate every visible variant in one call.
//   - `infinite(filter)` — TanStack `useInfiniteQuery` keeps `InfiniteData`
//     under its own slot so list-shape branching is unnecessary.
//   - `details()` / `detail(id)` — the detail view; `details()` is a
//     prefix-only key for invalidation-by-prefix.
//   - `versions(id)` — version history list for one aggregate.
//   - `version(id, versionId)` — one version snapshot.
export const clientsKeys = {
  all: ['clients'] as const,
  lists: () => ['clients', 'list'] as const,
  list: (filter: Record<string, unknown>) => ['clients', 'list', filter] as const,
  infinite: (filter: Record<string, unknown>) => ['clients', 'infinite', filter] as const,
  details: () => ['clients', 'detail'] as const,
  detail: (id: string) => ['clients', 'detail', id] as const,
  versions: (id: string) => ['clients', id, 'versions'] as const,
  version: (id: string, versionId: string) => ['clients', id, 'versions', versionId] as const,
};
